/**
 * About component
 *
 * Space for you to describe more about yourself.
 */

import React from "react";

/**
 * About background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that
 * represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a image you
 * freely use on your site.
 */
import image from "../images/oliver-pecker-HONJP8DyiSM-unsplash.jpg";

const imageAltText = "Background Laptop with mobile";

/**
 * Sort description that expands on your title on the Home component.
 */
const description =
  "I'm a student at National Institute of Technology Raipur aspiring to see myself as a Good Software Developer";

/**
 * List of some of skills or technologies you work on, are learning,
 * passionate about, or enjoy,
 */
const skillsList = [
  "C++",
  "Python",
  "JavaScript",
  "MySQL",
  "MongoDB",
  "Data Science",
  "Html",
  "CSS",
  "BootStrap",
  "React.Js",
  "Node.Js",
  "Machine Learning",
];

/**
 * Use this to give more information about what you are passionate about,
 * how you best work, or even a quote. This will help someone learn more
 * about you on a professional level.
 */
const detailOrQuote =
  "I am passionate about solving problems in new creative ways to drive innovation. I am proficient in using various development frameworks and tools such as NodeJS, ReactJS, and MongoDB.I aim to leverage my skills and experiences to contribute effectively in dynamic and innovative environments.";

const About = () => {
  return (
    <section className="padding" id="about">
      <img className="background" src={image} alt={imageAltText} />
      <div
        style={{
          backgroundColor: "white",
          width: "50%",
          padding: "4rem",
          margin: "3rem auto",
          textAlign: "center",
        }}
      >
        <h2>About Myself</h2>
        <p className="large">{description}</p>
        <hr />
        <h3 style={{ textAlign: "center", border: "2px solid" }}>
          <b>Skills</b>
        </h3>
        <ul
          style={{
            textAlign: "left",
            columns: 2,
            fontSize: "1.25rem",
            margin: "2rem 3rem",
            gap: "3rem",
          }}
        >
          {skillsList.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
        <hr />
        <p style={{ padding: "1rem 3rem 0" }}>{detailOrQuote}</p>
      </div>
    </section>
  );
};

export default About;
